export default __webpack_public_path__ + "static/pure-baby-pure-love-93eed3f22572ff288ab8edcb634fc7c4.png";